<template>
  <v-form
    id="otherDetails"
    v-model="valid"
  >
    <h2 class="header">
      Bank Details
    </h2>
    <v-row>
      <v-col
        cols="12"
        sm="5"
        class="d-flex align-start"
      >
        <v-text-field
          v-model="candidate.candidate_details.account_holder_name"
          :disabled="candidate.is_synced === 1"
          class="textField"
          label="Account Holder Name"
          filled
        />
        <v-tooltip
          top
        >
          <template v-slot:activator="{on}">
            <v-icon
              v-on="on"
            >
              mdi-help-circle
            </v-icon>
          </template>
          <span> {{ tooltip.accountHolder.text }} </span>
        </v-tooltip>
      </v-col>
      <v-col
        cols="7"
        sm="4"
        class="d-flex align-start"
      >
        <v-text-field
          v-model="candidate.candidate_details.account_number"
          :disabled="candidate.is_synced === 1"
          class="pl-4"
          label="Account Number"
          filled
          :counter="8"
          :rules="Rules.accountNumber"
        />
        <v-tooltip
          top
        >
          <template v-slot:activator="{on}">
            <v-icon
              v-on="on"
            >
              mdi-help-circle
            </v-icon>
          </template>
          <span> {{ tooltip.accountNumber.text }} </span>
        </v-tooltip>
      </v-col>
      <v-col
        cols="5"
        sm="3"
        class="d-flex align-start"
      >
        <v-text-field
          v-model="candidate.candidate_details.sort_code"
          v-mask="'##-##-##'"
          :disabled="candidate.is_synced === 1"
          label="Sort Code"
          class="pr-4"
          filled
          :rules="Rules.sortCode"
        />
        <v-tooltip
          top
        >
          <template v-slot:activator="{on}">
            <v-icon
              v-on="on"
            >
              mdi-help-circle
            </v-icon>
          </template>
          <span> {{ tooltip.sortCode.text }} </span>
        </v-tooltip>
      </v-col>
      <v-col
        cols="12"
        sm="4"
        class="d-flex align-start"
      >
        <v-autocomplete
          v-model="details.paye_type"
          :disabled="candidate.is_synced === 1"
          class="textField pr-4"
          filled
          :items="paymentTypes"
          auto-select-first
          label="Pay Type*"
          :rules="Rules.required"
        >
          <template v-slot:item="data">
            {{ data.item }}
          </template>
        </v-autocomplete>
        <v-dialog
          v-model="tooltip.paymentTypes.show"
          transition="dialog-bottom-transition"
          scrollable
        >
          <template v-slot:activator="{on}">
            <v-icon
              v-on="on"
            >
              mdi-help-circle
            </v-icon>
          </template>
          <v-card>
            <v-toolbar
              dark
              color="primary"
            >
              <v-btn
                icon
                dark
                @click="tooltip.paymentTypes.show = !tooltip.paymentTypes.show"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Pay Type Help</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <div
                v-for="(type, i) in paymentTypes"
                :key="i"
                class="mx-4 my-4"
              >
                <span> <b>{{ type }}: </b> {{ PayTypeDefinitions[type] }} </span>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
      <pay-type-component
        :paytype="details.paye_type"
        :name="candidate.candidate_details.pay_name_option"
        :number="candidate.candidate_details.pay_number_option"
        @payTypeOptionUpdated="updatePayTypeOption($event)"
        @nameOptionUpdated="updateNameOption($event)"
        @numberOptionUpdated="updateNumberOption($event)"
        @schemeOptionUpdated="updateSchemeOption($event)"
        @resetOptions="resetOptions($event)"
      />
    </v-row>
    <v-btn
      tile
      outlined
      color="agency-color-secondary"
      @click="goBack()"
    >
      Back
    </v-btn>
    <v-btn
      :disabled="!valid"
      tile
      dark
      color="agency-color-primary"
      @click="next()"
    >
      Next
    </v-btn>
  </v-form>
</template>
<script>
import { PayTypeDefinitions } from '../../../helpers/PayTypeDefinitions'
export default {
  name: 'OtherDetails',
  props: {
    candidate: {
      type: Object,
      default: () => {
        return {
          candidate_details: {},
          candidate_nok: {}
        }
      }
    }
  },
  data: () => ({
    PayTypeDefinitions,
    valid: false,
    details: {
      pay_name_option: null,
      pay_number_option: null,
      scheme_option: null,
      paye_type: 'PAYE'
    },
    tooltip: {
      accountHolder: {
        show: false,
        text: 'Please enter the name of the account holder who is legally responsible for the account. This can be found on a bank statement or cheque book'
      },
      accountNumber: {
        show: false,
        text: 'This is the account number you would like to receive payments into. It can be found on your bank statement, cheque book or online banking app'
      },
      sortCode: {
        show: false,
        text: 'This is the 6-digit number that identifies your bank and branch. It can be found on your bank statement, bank card, cheque book or online banking app usually in the format 00-00-00'
      },
      paymentTypes: {
        show: false
      }
    }
  }),
  computed: {
    paymentTypes () {
      return Object.keys(PayTypeDefinitions)
    }
  },
  created () {
    if (this.candidate.candidate_details.paye_type) {
      this.details.paye_type = this.candidate.candidate_details.paye_type
    } else {
      this.candidate.candidate_details.paye_type = 'PAYE'
      this.resetOptions()
    }
  },
  methods: {
    next () {
      this.$emit('next', {
        newCandidate: this.candidate
      })
      localStorage.setItem('candidate_register', JSON.stringify(this.candidate))
    },
    goBack () {
      this.$emit('back')
    },
    updatePayTypeOption ($event) {
      this.candidate.candidate_details.paye_type = $event
    },
    updateNameOption ($event) {
      this.candidate.candidate_details.pay_name_option = $event
    },
    updateNumberOption ($event) {
      this.candidate.candidate_details.pay_number_option = $event
    },
    updateSchemeOption ($event) {
      this.candidate.candidate_details.scheme_option = $event
    },
    resetOptions () {
      this.candidate.candidate_details.pay_name_option = null
      this.candidate.candidate_details.pay_number_option = null
      this.candidate.candidate_details.scheme_option = null
    }
  }
}
</script>
